<!---modules1-Main-->
<template>
  <div class="section-main__warp flex-row">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Main",
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
